// Module
var code = "<h3>Enlightenment Questions - Question From V</h3> <p>Dear Tathagata,</p> <p>How our universe looks like on the whole ( the shape) ?</p> <p>What exists outside universe?</p> <p>Thanks</p> <p>V</p> ";
// Exports
module.exports = code;